<template>
    <div id="app" ref="app" @scroll="handleScroll">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />


        <el-backtop target="#app" style="z-index: 100;"></el-backtop>

        <div v-if="showDuck" class="popover" v-drag>
            <el-image class="popover-img" src="/web/image/logo0.png">
            </el-image>
            <div class="popover-item first bold" @click="to('/main/download')"><a>{{ $t('题库下载') }}</a></div>
            <div class="popover-line"></div>
            <el-popover class="aa" placement="left" width="300" :offset="0" trigger="hover">
                <lazy-component wrapper-tag="section">
                    <el-image class="qrode-img" :src="`/web/image/home/app_qrcode${$store.state.lang}.jpg`"></el-image>
                </lazy-component>
                <div class="popover-item bold" slot="reference"><a>{{ $t('APP下载') }}</a></div>
            </el-popover>
            <div class="popover-line"></div>
            <el-popover class="aa" placement="left" width="300" :offset="0" trigger="hover">
                <lazy-component wrapper-tag="section">
                    <el-image class="qrode-img" :src="$host + $store.state.setting.kf_qrcode"></el-image>
                </lazy-component>
                <div class="popover-item bold" slot="reference"><a>{{ $t('联系客服') }}</a></div>
            </el-popover>
            <div class="popover-line"></div>


            <div @click="to('/media?tag=article&id=4')" class="popover-item bold" slot="reference"><a>{{ $t('关于我们')
            }}</a>
            </div>
            <div class="popover-line"></div>
        </div>
    </div>
</template>

<script>
import DevToolsDetector from 'devtools-detector';
import locale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en';
import zh from 'element-ui/lib/locale/lang/zh-CN';
import tw from 'element-ui/lib/locale/lang/zh-TW';

export default {
    data() {
        return {
            showDuck: true,
            top: "40%",
            left: "calc(100vw - 160px)",
            dragging: false,
            scrollInfo: {},
        }
    },

    directives: {
        drag(el) {
            el.style.cursor = 'move'

            el.onmousedown = function (e) {
                var disx = e.pageX - el.offsetLeft;
                var disy = e.pageY - el.offsetTop;

                if (e.preventDefault) {
                    e.preventDefault()
                } else {
                    e.returnValue = false  // 解决快速频繁拖动滞后问题
                }

                document.onmousemove = function (e) {
                    // 鼠标位置-鼠标相对元素位置=元素位置
                    let left = e.clientX - disx;
                    let top = e.clientY - disy;
                    // 限制拖拽范围不超出可视区
                    if (left <= 0) {
                        left = 5    // 设置成5,离边缘不要太近
                    } else if (left > document.documentElement.clientWidth - el.clientWidth) { // document.documentElement.clientWidth屏幕可视区宽度
                        left = document.documentElement.clientWidth - el.clientWidth - 5
                    }


                    if (top <= 0) {
                        top = 5
                    } else if (top > document.documentElement.clientHeight - el.clientHeight) {
                        top = document.documentElement.clientHeight - el.clientHeight - 5
                    }
                    console.log(document.documentElement.clientHeight, el.clientHeight)
                    el.style.left = left + 'px'
                    el.style.top = top + 'px'
                }

                document.onmouseup = function () {
                    document.onmousemove = document.onmouseup = null
                }
            }
        }
    },

    computed: {
        lang: function () {
            return this.$store.state.lang;
        },
        locales() {
            return this.$store.state.locales;
        }
    },

    watch: {
        lang() {
            this.setLang()
        },
        locales() {
            document.title = this.$t('海澳英语-PTE/CCL培训');
        },
        $route(route) {
            if (route.path == '/mock' || route.path == '/privacy') {
                this.showDuck = false;
            } else {
                this.showDuck = true;
            }
        }
    },

    created() {
        this.setLang();
        this.$store.dispatch("fetch_locales");
        this.$store.dispatch("fetch_sorts");

        this.$http.post("/api/user/info").then((user) => {
            this.$store.commit("setUser", user);
        })

        this.$http.post("/api/setting").then((setting) => {
            this.$store.commit("setSetting", setting);
        })



        this.$bus.$on("scrollTop", (top) => {
            if (top == undefined) {
                let key = this.$route.path.replace("/", "_");
                top = this.scrollInfo[key] || 0;
            }
            this.$refs.app.scrollTop = top;
        })
    },

    mounted() {
        if (process.env.NODE_ENV != "development") {
            DevToolsDetector.addListener(this.handleDevToolsChange);
            DevToolsDetector.launch();
            this.$nextTick(() => {
                // 禁用右键
                document.oncontextmenu = new Function("event.returnValue=false");
                document.addEventListener('contextmenu', this.handleContextMenu);
                // 禁用选择
                document.onselectstart = new Function("event.returnValue=false");
            });
        }
    },

    beforeDestroy() {
        DevToolsDetector.removeListener(this.handleDevToolsChange);
    },

    methods: {
        handleDevToolsChange(isOpen) {
            if (isOpen) {
                window.close()
                window.location.replace('about:blank')
            }
        },


        handleContextMenu(e) {
            // 检查是否点击了允许右键的元素
            const isAllowed = e.target.closest('.search-input') !== null;
            if (!isAllowed) {
                e.preventDefault();
            }
        },
        setLang() {
            this.$store.commit("set_reload", true);
            if (this.lang == 'en') {
                locale.use(en);
            } else if (this.lang == 'tw') {
                locale.use(tw);
            } else {
                locale.use(zh);
            }
            document.title = this.$t('海澳英语-PTE/CCL培训');
            this.$nextTick(() => {
                this.$store.commit("set_reload", false);
            });
        },
        to(url) {
            this.$router.push(url)
        },
        handleScroll(e) {
            let key = this.$route.path.replace("/", "_");
            this.scrollInfo[key] = e.target.scrollTop;
            this.$bus.$emit("scroll", e.target.scrollTop)
        }
    }
}


</script>



<style>
#app {
    overflow-y: scroll;
    height: 100vh;
    width: 100%;
    min-width: 1220px;
}

.popover {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100px;
    top: 55%;
    left: calc(100vw - 100px);
    /* border-radius: 8px; */
    /* background-color: #fff; */
    position: fixed;
    z-index: 888;
    overflow: hidden;
    /* border: 1px solid #eee; */
    transition: height 0.1s ease-in;
    width: 100px;
}

.popover:hover {
    height: auto;
    transition: height 0.1s ease-out;
}

.popover-item {
    font-size: 16px;
    background: #fff;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;
    width: 100px;
}

.popover-item:hover+.popover-line,
.aa:hover+.popover-line {
    background-color: #e6a13c;
    height: 2px;
    border-radius: 1px;
}





.first {
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

.end {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
}

.popover-img {
    margin: 10px;
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    cursor: pointer;
}

.qrode-img {
    width: 300px;
    height: 300px;
}

.popover-line {
    flex-shrink: 0;
    height: 1px;
    margin: 0 auto;
    width: 40px;
    background-color: #aaa;
}

.my-tooltip {
    border-color: #EBEEF5 !important;
}

.my-tooltip .popper__arrow {
    border-bottom-color: #EBEEF5 !important;
}
</style>
